"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "hold-selector" };
var _hoisted_2 = { class: "hold-title" };
var _hoisted_3 = { class: "radio-option-group" };
var _hoisted_4 = { class: "radio-option" };
var _hoisted_5 = { class: "radio-option" };
var _hoisted_6 = {
    key: 0,
    class: "times-selection-section"
};
var _hoisted_7 = { class: "times-selection-header" };
var _hoisted_8 = { class: "times-selection-list" };
var _hoisted_9 = ["value", "disabled"];
var _hoisted_10 = {
    key: 1,
    class: "scheduling-container"
};
var _hoisted_11 = { class: "confirm-scheddt-sec" };
var _hoisted_12 = { class: "frst-row" };
var _hoisted_13 = { class: "rw-dt" };
var _hoisted_14 = { class: "sec-row" };
var _hoisted_15 = { class: "rw-dt" };
var _hoisted_16 = ["placeholder"];
var _hoisted_17 = { class: "action-buttons" };
var _hoisted_18 = ["disabled"];
var _hoisted_19 = ["disable"];
var _hoisted_20 = ["disable"];
var _hoisted_21 = ["disable"];
var _hoisted_22 = {
    key: 2,
    class: "prev-schedHold"
};
var _hoisted_23 = { class: "sched-text-container" };
var _hoisted_24 = { class: "sched-startddt" };
var _hoisted_25 = { class: "sched-enddt" };
var _hoisted_26 = {
    key: 0,
    class: "update-scection"
};
var _hoisted_27 = { class: "updt-current-hold" };
var _hoisted_28 = { class: "cancel-current-hold" };
var vue_3 = require("vue");
var dateOnly_1 = require("@/utils/dateOnly");
//import Datepicker from '@vuepic/vue-datepicker'
// import '@vuepic/vue-datepicker/dist/main.css'
/**
 * Props:
 *  - statusOption: 'hold' | 'new' | 'discontinue'
 *  - medicationTimes: e.g. ["09:30","12:05"]
 */
exports.default = (0, vue_1.defineComponent)({
    __name: 'HoldTimeSelector',
    props: {
        statusOption: {},
        medicationTimes: {},
        timepairs: {},
        medObj: {}
    },
    emits: ["submit", "submit-schedule", "cancel"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var isnull = (0, vue_3.ref)('');
        (0, vue_3.watch)(function () { return props.medObj.schedHoldStartDate; }, function (newVal, oldVal) {
            if (newVal === oldVal)
                return;
        }, { immediate: true });
        (0, vue_3.onMounted)(function () {
            var _a, _b;
            //let make an axios call but first lets check the medObje data and we may can circumvent the call
            console.log("Scheduling Start Date passed:");
            console.log(props.medObj.schedHoldStartDate);
            isnull.value = (_b = (_a = props.medObj) === null || _a === void 0 ? void 0 : _a.schedHoldStartDate) === null || _b === void 0 ? void 0 : _b.value;
            if (props.medObj.schedHoldStartDate !== undefined && props.medObj.schedHoldStartDate !== null) {
                doesHoldExistAlready.value = true;
                pendingSchedHold.value = true;
            }
            else {
                doesHoldExistAlready.value = false;
                pendingSchedHold.value = false;
            }
        });
        /**
         * Emits:
         *  - "submit" => user clicked Submit with
         *                { dateRange, times, reason, holdType, statusOption }.
         *  - "cancel" => user clicked Cancel.
         */
        var emit = __emit;
        // "all" => all times on that date, "specific" => only selected
        var timeSelection = (0, vue_3.ref)('all');
        var schedStartDt = (0, vue_3.ref)(''); //dt string
        var schedEndDt = (0, vue_3.ref)(''); //end scheudle dt string 
        var isScheduleHold = (0, vue_3.ref)(false);
        var doesHoldExistAlready = (0, vue_3.ref)(false);
        var ifshowEditOptions = (0, vue_3.ref)(false);
        var pendingSchedHold = (0, vue_3.ref)(false);
        var cancelHold = (0, vue_3.ref)('');
        // Single date
        //const selectedDate = ref<Date | null>(null)
        //multiple dates 
        var selectedDate = (0, vue_3.ref)([]); // Use an array to hold multiple dates
        // Times user checked if timeSelection='specific'
        var selectedTimes = (0, vue_3.ref)([]);
        // Reason
        var reasonValue = (0, vue_3.ref)('');
        var scheduleDtar = (0, vue_3.ref)([]);
        // Dynamic placeholder text
        var reasonPlaceholder = (0, vue_3.computed)(function () {
            if (props.statusOption === 'new') {
                return 'Enter reason for new';
            }
            else if (props.statusOption === 'discontinue') {
                return 'Enter reason for discontinue';
            }
            else if (props.statusOption === 'change') {
                return 'Enter reason for Change';
            }
            return 'Enter reason for hold';
        });
        var isScheduleHoldText = (0, vue_3.ref)('');
        // Form is valid if we have a date + reason, and times if "specific"
        /*const isValid = computed(() => {
          if (!selectedDate.value || !reasonValue.value.trim()) {
            return false
          }
          if (timeSelection.value === 'specific' && selectedTimes.value.length === 0) {
            return false
          }
          return true
        }); */
        function showEditOptions(e) {
            console.log("Event Traget INformation");
            console.log(e.currentTarget);
            if (ifshowEditOptions.value == true) {
                ifshowEditOptions.value = false;
                return ifshowEditOptions.value;
            }
            else {
                ifshowEditOptions.value = true;
                return ifshowEditOptions.value;
            }
        }
        /*Function to cross check calendar dates to determine the current date*/
        function isSameDay(a, b) {
            return a.getFullYear() === b.getFullYear()
                && a.getMonth() === b.getMonth()
                && a.getDate() === b.getDate();
        }
        /*
        * datepicker callthis for each date, return true to disable the date
        * uses statusOption == discontinue -> disable all days except today
        * Otherwise don't disable anything here
        */
        function doUpdtSchedHold(e) {
            var checked = e.target.checked;
            if (checked) {
                //alert("Doing Update")
                selectedDate.value = [];
                var date1 = localNoonFromYMD(props.medObj.schedHoldStartDate);
                var date2 = localNoonFromYMD(props.medObj.schedHoldEndDate);
                selectedDate.value.push(date1, date2);
                console.log("New Seelcted Cancel Dates");
                console.log(selectedDate.value);
                isScheduleHoldText.value = "There is a currnet Hold in place, please update the calendar dates and reason before submitting this request.";
                //set the Two-Way Bind ref variables for Schedule Start and End Date
                schedStartDt.value = toYYYYMMDD(date1);
                schedEndDt.value = toYYYYMMDD(date2);
                isScheduleHold.value = true;
            }
            else {
                //unchecking simply closes modal (if open)
                selectedDate.value = [];
                schedStartDt.value = "";
                schedEndDt.value = "";
                isScheduleHold.value = false;
            }
        }
        function cancelSchedHold(e) {
            var checked = e.target.checked;
            if (checked) {
                // alert("Cancel Hold");
                cancelHold.value = "cancel";
                //now set heldt and call DoesExist function to pressit cancel hold button 
                // const cancelstholddate = props.medObj.medholdstartdate; // toYYYYMMDD(heldDt[0]);
                // const cancelendholddate =  props.medObj.medholdendate; //toYYYYMMDD(heldDt[1]);
                //making sure that we cancel any date that may be in the Date Picker before setting it with cancel dates
                selectedDate.value = [];
                var date1 = localNoonFromYMD(props.medObj.schedHoldStartDate);
                var date2 = localNoonFromYMD(props.medObj.schedHoldEndDate);
                selectedDate.value.push(date1, date2);
                console.log("New Seelcted Cancel Dates");
                console.log(selectedDate.value);
            }
            else {
                //do nothing 
                selectedDate.value = [];
                cancelHold.value = "";
            }
        }
        function disableExceptTodayIfDiscontinue(date) {
            if (props.statusOption === 'discontinue') {
                var today = new Date();
                return !isSameDay(date, today); // true => disabled, so disable when not today
            }
            return false; // no disabled dates for other hold types
        }
        // 2026-10 (#335): the local day, not toISOString()'s UTC day. From 20:00 EDT
        // the UTC day is tomorrow, so a hold starting today was offered as a scheduled
        // hold and its end date showed a day late.
        function toYYYYMMDD(d) {
            return (0, dateOnly_1.toLocalYMD)(new Date(d));
        }
        function UTCTimeShiftAdjustment(now) {
            var fixdate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0, 0);
            return fixdate;
        }
        function localNoonFromYMD(ymd) {
            if (!ymd)
                return null;
            var parts = ymd.trim().split('-');
            if (parts.length !== 3)
                return null;
            var year = Number(parts[0]);
            var monthIndex = Number(parts[1]) - 1; // 0..11
            var day = Number(parts[2]);
            if (Number.isNaN(year) || Number.isNaN(monthIndex) || Number.isNaN(day))
                return null;
            return new Date(year, monthIndex, day, 12, 0, 0, 0); // local time at noon
        }
        //311/26 Date Format FUnction added (kW)
        function checkIfHoldStDtExist(statusOption, heldDt) {
            console.log("I want to veiew whats in the Med Prop Object that was sent over");
            console.log(props.medObj);
            console.log("MedHoldStartDate" + " " + props.medObj.medholdstartdate + " ENd Date: " + props.medObj.medholdenddate);
            var medholdstartdate = props.medObj.medholdstartdate || '';
            var medholdendate = props.medObj.medholdenddate || '';
            if (statusOption == "hold" && heldDt != null && heldDt.length == 2) {
                var stholddate = toYYYYMMDD(heldDt[0]);
                var endholddate = toYYYYMMDD(heldDt[1]);
                var tshftStrtdate = UTCTimeShiftAdjustment(heldDt[0]);
                var now = new Date();
                var todayDate = UTCTimeShiftAdjustment(now); // new Date(now.getFullYear(),now.getMonth(),now.getDate(),12,0,0,0);
                //3/11/26 Compre Start date to see if If past today's date in the future and if so its potentially scheduling Holds
                if (stholddate > toYYYYMMDD(todayDate) && doesHoldExistAlready.value == false) {
                    // alert("Its the future")
                    schedStartDt.value = toYYYYMMDD(tshftStrtdate); // stholddate; //Should set the Scheduling Dates (3/11/26)
                    schedEndDt.value = endholddate; //should set the Scheduling Dates (3/11/26)
                    //now push into array
                    scheduleDtar.value.push(schedStartDt.value, schedEndDt.value);
                    isScheduleHoldText.value = "Confirming that you want to schedule a Medication Hold for the selected administration times.";
                    isScheduleHold.value = true;
                }
                else {
                    //lets turn off isScheduleHold value if it is on and user cancel the dates and reinput new dates
                    isScheduleHold.value = false;
                    isScheduleHoldText.value = "";
                }
                if (stholddate > toYYYYMMDD(todayDate) && doesHoldExistAlready.value == true) {
                    //alert("Its the Futre but hold already in place");
                    schedStartDt.value = stholddate; //Should set the Scheduling Dates (3/11/26)
                    schedEndDt.value = endholddate; //should set the Scheduling Dates (3/11/26)
                    scheduleDtar.value.push(schedStartDt.value, schedEndDt.value);
                    isScheduleHoldText.value = "There is a currnet Hold in place, Do you want to update or cancel the Scheduled Hold? Check the option of choice below. ";
                    isScheduleHold.value = true;
                }
                //todayDate.setHours(12,0,0,0); //keep day stable 
                //const nwtodayDate =toYYYYMMDD(todayDate);
                //alert(todayDate);
                //evaluate dates 
                /*1. split dates if needed due to the Group Concact
                2. Assign start date to the first index
                3. Assign end date to the first index of the mebObje.medholdendate
                */
                if (medholdstartdate == null || medholdendate == null) {
                    console.log("No Previous Hold Date Set In Place");
                }
                else {
                    //Okay lets compare dates 
                    var mstrtdates = medholdstartdate.split(",").map(function (s) { return s.trim(); });
                    var menddates = medholdendate.split(",").map(function (s) { return s.trim(); });
                    if (stholddate > medholdstartdate[0] && endholddate >= medholdendate[0]) {
                        selectedDate.value = [];
                        //fixing the UTC TIme Shit issue for the end Date (startdate addressed earlier)
                        //alert("End Date Before Conversio"+" "+menddates[0]);
                        var finalendDate = localNoonFromYMD(menddates[0]);
                        //alert("Final End Date"+ " "+ finalendDate);
                        selectedDate.value = [todayDate, finalendDate]; //menddates[0]
                        alert("Sorry, there is aleready an existing Hold Start and End Date previously set. All future times associated with this " +
                            "medication will all have the same semittart and end Date.");
                        //return selectedDate;
                        console.log("Today's Date for Hled Time Function");
                        console.log(selectedDate.value);
                    }
                }
            }
            else {
                //param is null so lets reset  it to am empty array 
                // heldDt = [];
                selectedDate.value = heldDt || [];
            }
        }
        // time => status map kept in sync
        var heldTimeMap = {}; // plain object map string->string
        /*Adding Code to send over hold or dc if they exist*/
        function getHeldTimesForSubmit(action, holdType) {
            if (!['hold', 'discontinue'].includes(action))
                return [];
            if (holdType !== 'specific')
                return [];
            // Ensure map is current
            updateHeldTimeMap();
            // Convert map to array of { time, status } for server
            return Object.keys(heldTimeMap).map(function (time) { return ({ time: time, status: heldTimeMap[time] }); });
        }
        /* End hold or dc newcode*/
        function updateHeldTimeMap() {
            var _a;
            heldTimeMap = {}; //reset 
            var pairs = parseTimeStatusPairs((_a = props.timepairs) !== null && _a !== void 0 ? _a : null);
            pairs.forEach(function (p) {
                var _a;
                var t = normalizeTime(p.time);
                var s = String((_a = p.status) !== null && _a !== void 0 ? _a : '').trim();
                if (!t)
                    return;
                if (['hold-medtime', 'discontinue-medtime'].includes(s)) {
                    heldTimeMap[t] = s; //
                }
            });
        }
        function isActiveTime(timeToCheck) {
            var _a;
            if (timeToCheck === void 0) { timeToCheck = ''; }
            console.log("Props Time Pairs data");
            console.log(props.timepairs);
            updateHeldTimeMap(); // keep heldTimeMap up-to-date
            var pairs = parseTimeStatusPairs((_a = props.timepairs) !== null && _a !== void 0 ? _a : null);
            console.log("Want to see waht pairs look like");
            console.log(pairs);
            var t = normalizeTime(timeToCheck);
            if (!t)
                return false;
            return pairs.some(function (p) { return normalizeTime(p.time) === t && (String(p.status) === 'taken' || String(p.status) === 'hold-medtime' || String(p.status) === 'discontinue-medtime'); });
        }
        function normalizeTime(t) {
            if (!t)
                return '';
            // strip seconds if any: "08:00:00" -> "08:00"
            return String(t).split(':').slice(0, 2).join(':');
        }
        function parseTimeStatusPairs(pairsStr) {
            if (!pairsStr)
                return [];
            // If already an array (e.g. server returned JSON), coerce to plain array
            if (Array.isArray(pairsStr))
                return pairsStr;
            // If it's a Vue ref, unwrap
            if (pairsStr && typeof pairsStr === 'object' && pairsStr.hasOwnProperty('value')) {
                return parseTimeStatusPairs(pairsStr.value);
            }
            // If JSON string
            if (typeof pairsStr === 'string') {
                // try JSON parse first
                try {
                    var parsed = JSON.parse(pairsStr);
                    if (Array.isArray(parsed))
                        return parsed;
                }
                catch (e) { /* not JSON, continue */ }
                // expected token format: "time||takentime||status||reason, time2||..."
                return pairsStr
                    .split(',')
                    .map(function (s) { return s.trim(); })
                    .map(function (entry) {
                    var _a, _b, _c, _d;
                    var parts = entry.split('||').map(function (p) { return (p !== null && p !== void 0 ? p : '').trim(); });
                    return {
                        time: (_a = parts[0]) !== null && _a !== void 0 ? _a : '',
                        takentime: (_b = parts[1]) !== null && _b !== void 0 ? _b : '',
                        status: (_c = parts[2]) !== null && _c !== void 0 ? _c : '',
                        reason: (_d = parts[3]) !== null && _d !== void 0 ? _d : ''
                    };
                })
                    // FILTER OUT entries where EVERY field is empty (this removes "|||" entries)
                    .filter(function (obj) { return (obj.time || obj.takentime || obj.status || obj.reason); });
            }
            // If an object containing an array field like { pairs: [...] }
            if (pairsStr && typeof pairsStr === 'object') {
                if (Array.isArray(pairsStr.pairs))
                    return pairsStr.pairs;
                if (Array.isArray(pairsStr.data))
                    return pairsStr.data;
            }
            return [];
        }
        /*function handleSubmit() {
          if (!isValid.value || !selectedDate.value) return
        
          // Single day => wrap in [start,end] for the parent
          const dateRange: [Date, Date] = [ selectedDate.value[0], selectedDate.value[1] ]
        
          emit('submit', {
            dateRange,
            times: (timeSelection.value === 'specific') ? selectedTimes.value : null,
            reason: reasonValue.value.trim(),
            holdType: timeSelection.value,
            statusOption: props.statusOption
          })
        
          // Reset
          selectedDate.value = [];//null
          selectedTimes.value = []
          reasonValue.value = ''
          timeSelection.value = 'all'
        } */
        // helper: accept Date | string | null | undefined -> Date | null
        function asDate(raw) {
            if (!raw)
                return null;
            if (raw instanceof Date)
                return isNaN(raw.getTime()) ? null : raw;
            var d = new Date(String(raw));
            return isNaN(d.getTime()) ? null : d;
        }
        var isValid = (0, vue_3.computed)(function () {
            var _a, _b;
            if (!reasonValue.value.trim())
                return false;
            var raw = selectedDate.value;
            var first = null;
            var second = null;
            if (Array.isArray(raw)) {
                first = asDate((_a = raw[0]) !== null && _a !== void 0 ? _a : null);
                second = asDate((_b = raw[1]) !== null && _b !== void 0 ? _b : null);
            }
            else {
                first = asDate(raw !== null && raw !== void 0 ? raw : null); // single-date picker returns here
            }
            if (props.statusOption === 'discontinue') {
                return !!first; // allow a single valid date
            }
            // other statuses require two dates
            if (!first || !second)
                return false;
            if (timeSelection.value === 'specific' && selectedTimes.value.length === 0)
                return false;
            return true;
        });
        function handleSchedulSubmit(e) {
            var _a, _b;
            if (!isValid.value)
                return;
            var ev = e.currentTarget;
            console.log("Event Object HandleScheduleSubmit");
            console.log(ev);
            var raw = selectedDate.value;
            var start = null;
            var end = null;
            var errmsg = "";
            if (Array.isArray(raw)) {
                start = asDate((_a = raw[0]) !== null && _a !== void 0 ? _a : null);
                end = asDate((_b = raw[1]) !== null && _b !== void 0 ? _b : null);
            }
            else {
                errmsg = "Not a valid Date Range, Please select a valid Start and End Date.";
                return errmsg;
            }
            //check action/statusOption to call getheldtimesorSubmit
            if (props.statusOption === 'hold' && Object.keys(heldTimeMap).length > 0) {
                getHeldTimesForSubmit(props.statusOption, timeSelection.value);
            }
            if (props.statusOption === 'discontinue') {
                errmsg = "You can only schedule Holds at this time. Sorry, Please DC for today's date or go back and schedule a Hold.";
                return errmsg;
            }
            //adding action variable here so the axio/tswebhook knows how to process the request 
            var action = "";
            if (doesHoldExistAlready.value == true && cancelHold.value != "cancel") {
                action = "update";
            }
            else if (cancelHold.value == 'cancel') {
                action = "cancel";
            }
            else {
                action = "schedule";
            }
            if (!start || !end)
                return;
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);
            emitSubmitHold([start, end], isScheduleHold.value, action);
        }
        function handleSubmit() {
            var _a, _b;
            if (!isValid.value)
                return;
            var raw = selectedDate.value;
            var start = null;
            var end = null;
            if (Array.isArray(raw)) {
                start = asDate((_a = raw[0]) !== null && _a !== void 0 ? _a : null);
                end = asDate((_b = raw[1]) !== null && _b !== void 0 ? _b : null);
            }
            else {
                start = asDate(raw !== null && raw !== void 0 ? raw : null);
            }
            //check action/statusOption to call getheldtimesorSubmit
            if ((props.statusOption === 'discontinue' || props.statusOption === 'hold') && Object.keys(heldTimeMap).length > 0) {
                getHeldTimesForSubmit(props.statusOption, timeSelection.value);
            }
            if (props.statusOption === 'discontinue') {
                if (!start)
                    return;
                start.setHours(0, 0, 0, 0);
                var dateRange = [start, new Date(start.getTime())];
                emitSubmit(dateRange);
                return;
            }
            if (!start || !end)
                return;
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);
            emitSubmit([start, end]);
        }
        function emitSubmitHold(dateRange, isScheduled, action) {
            if (Object.keys(heldTimeMap).length === 0 && (isScheduled === true || doesHoldExistAlready.value === true)) {
                emit('submit-schedule', {
                    dateRange: dateRange,
                    times: (timeSelection.value === 'specific') ? selectedTimes.value : null,
                    reason: reasonValue.value.trim(),
                    holdType: timeSelection.value,
                    statusOption: props.statusOption,
                    archiveHLDDC: {},
                    schedDt: scheduleDtar,
                    action: action
                });
            }
            else {
                emit('submit-schedule', {
                    dateRange: dateRange,
                    times: (timeSelection.value === 'specific') ? selectedTimes.value : null,
                    reason: reasonValue.value.trim(),
                    holdType: timeSelection.value,
                    statusOption: props.statusOption,
                    archiveHLDDC: heldTimeMap,
                    schedDt: scheduleDtar
                });
            }
            // reset
            selectedDate.value = [];
            selectedTimes.value = [];
            reasonValue.value = '';
            timeSelection.value = 'all';
        }
        function emitSubmit(dateRange) {
            //if heldTimeMap is empty send regular emit 
            if (Object.keys(heldTimeMap).length === 0) {
                emit('submit', {
                    dateRange: dateRange,
                    times: (timeSelection.value === 'specific') ? selectedTimes.value : null,
                    reason: reasonValue.value.trim(),
                    holdType: timeSelection.value,
                    statusOption: props.statusOption,
                    archiveHLDDC: {}
                });
            }
            else {
                emit('submit', {
                    dateRange: dateRange,
                    times: (timeSelection.value === 'specific') ? selectedTimes.value : null,
                    reason: reasonValue.value.trim(),
                    holdType: timeSelection.value,
                    statusOption: props.statusOption,
                    archiveHLDDC: heldTimeMap
                });
            }
            // reset
            selectedDate.value = [];
            selectedTimes.value = [];
            reasonValue.value = '';
            timeSelection.value = 'all';
        }
        return function (_ctx, _cache) {
            var _component_Datepicker = (0, vue_2.resolveComponent)("Datepicker");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("h2", _hoisted_2, (0, vue_2.toDisplayString)(_ctx.statusOption === 'new'
                    ? 'New Medication'
                    : _ctx.statusOption === 'discontinue'
                        ? 'Discontinue Medication'
                        : _ctx.statusOption === 'change'
                            ? 'Change Current Medication'
                            : 'Hold Medication'), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("label", _hoisted_4, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((timeSelection).value = $event); }),
                            value: "all",
                            name: "timeSelection"
                        }, null, 512), [
                            [vue_2.vModelRadio, timeSelection.value]
                        ]),
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(_ctx.statusOption === 'new'
                            ? 'New All Times'
                            : _ctx.statusOption === 'discontinue'
                                ? 'Discontinue All Times'
                                : 'Hold All Times'), 1)
                    ]),
                    (0, vue_2.createElementVNode)("label", _hoisted_5, [
                        (_ctx.statusOption != 'discontinue')
                            ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                                key: 0,
                                type: "radio",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((timeSelection).value = $event); }),
                                value: "specific",
                                name: "timeSelection"
                            }, null, 512)), [
                                [vue_2.vModelRadio, timeSelection.value]
                            ])
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(_ctx.statusOption === 'new'
                            ? 'New Specific Times'
                            : _ctx.statusOption === 'hold'
                                ? 'Hold Specific Times'
                                : ''), 1)
                    ])
                ]),
                (timeSelection.value === 'specific')
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)(_ctx.statusOption === 'new'
                            ? 'Select times to mark as New:'
                            : _ctx.statusOption === 'discontinue'
                                ? 'Select times to discontinue:'
                                : 'Select times to hold:'), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(_ctx.medicationTimes, function (time) {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                    key: time,
                                    class: "time-checkbox-label"
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        type: "checkbox",
                                        value: time,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((selectedTimes).value = $event); }),
                                        disabled: !!isActiveTime(time)
                                    }, null, 8, _hoisted_9), [
                                        [vue_2.vModelCheckbox, selectedTimes.value]
                                    ]),
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(time), 1)
                                ]));
                            }), 128))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(_component_Datepicker, {
                    modelValue: selectedDate.value,
                    "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = function ($event) { return ((selectedDate).value = $event); }),
                        _cache[4] || (_cache[4] = function ($event) { return (checkIfHoldStDtExist(_ctx.statusOption, selectedDate.value)); })
                    ],
                    placeholder: "Select date",
                    "auto-apply": "",
                    range: props.statusOption !== 'discontinue',
                    "text-input": "",
                    class: "status-datepicker",
                    format: 'yyyy-MM-dd',
                    "show-time": false,
                    "min-date": new Date(),
                    "disabled-dates": disableExceptTodayIfDiscontinue
                }, null, 8, ["modelValue", "range", "min-date"]),
                (isScheduleHold.value == true)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                        (0, vue_2.createElementVNode)("p", null, [
                            _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("span", { style: { "font-weight": "900", "color": "#ff0000" } }, "*", -1)),
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isScheduleHoldText.value), 1)
                        ]),
                        (0, vue_2.createElementVNode)("section", _hoisted_11, [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("span", null, "Start Date:", -1)),
                                (0, vue_2.createElementVNode)("span", _hoisted_13, (0, vue_2.toDisplayString)(schedStartDt.value), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("span", null, "End Date:", -1)),
                                (0, vue_2.createElementVNode)("span", _hoisted_15, (0, vue_2.toDisplayString)(schedEndDt.value), 1)
                            ])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((reasonValue).value = $event); }),
                    type: "text",
                    placeholder: reasonPlaceholder.value,
                    class: "status-reason"
                }, null, 8, _hoisted_16), [
                    [vue_2.vModelText, reasonValue.value]
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_17, [
                    (!isScheduleHold.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 0,
                            class: (0, vue_2.normalizeClass)(["submit-button", { 'submit-button-enabled': isValid.value }]),
                            disabled: !isValid.value,
                            onClick: handleSubmit
                        }, " Submit ", 10, _hoisted_18))
                        : (isScheduleHold.value == true && doesHoldExistAlready.value != true)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                key: 1,
                                class: (0, vue_2.normalizeClass)(["submit-button", { 'submit-button-enabled': isValid.value }]),
                                disable: !isValid.value,
                                onClick: handleSchedulSubmit
                            }, "Schedule Hold ", 10, _hoisted_19))
                            : (isScheduleHold.value == true && doesHoldExistAlready.value == true)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 2,
                                    class: (0, vue_2.normalizeClass)(["submit-button", { 'submit-button-enabled': isValid.value }]),
                                    disable: !isValid.value,
                                    onClick: handleSchedulSubmit
                                }, "Update Scheduled Hold ", 10, _hoisted_20))
                                : (0, vue_2.createCommentVNode)("", true),
                    (doesHoldExistAlready.value && cancelHold.value === 'cancel')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 3,
                            class: (0, vue_2.normalizeClass)(["submit-button", { 'submit-button-enabled': isValid.value }]),
                            disable: !isValid.value,
                            onClick: handleSchedulSubmit
                        }, "Cancel Hold ", 10, _hoisted_21))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("button", {
                        class: "cancel-button",
                        onClick: _cache[6] || (_cache[6] = function ($event) { return (_ctx.$emit('cancel')); })
                    }, " Cancel ")
                ]),
                (doesHoldExistAlready.value == true)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                        _cache[15] || (_cache[15] = (0, vue_2.createElementVNode)("div", { class: "yellow-container" }, [
                            (0, vue_2.createElementVNode)("span", { class: "ylw-con-text" }, "Scheduled Hold Information:")
                        ], -1)),
                        (0, vue_2.createElementVNode)("div", _hoisted_23, [
                            (0, vue_2.createElementVNode)("span", _hoisted_24, [
                                _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("b", { style: { "color": "#000" } }, "Start Date", -1)),
                                (0, vue_2.createTextVNode)(": " + (0, vue_2.toDisplayString)(props.medObj.schedHoldStartDate), 1)
                            ]),
                            _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("span", { class: "sched-divider" }, "|", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_25, [
                                _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("b", { style: { "color": "#000" } }, "End Date", -1)),
                                (0, vue_2.createTextVNode)(": " + (0, vue_2.toDisplayString)(props.medObj.schedHoldEndDate), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", { class: "edit-link-sec" }, [
                                (0, vue_2.createElementVNode)("span", {
                                    onClick: showEditOptions,
                                    class: "edit-link"
                                }, "Edit")
                            ]),
                            (ifshowEditOptions.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_26, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_27, [
                                        (0, vue_2.createElementVNode)("label", null, [
                                            (0, vue_2.createElementVNode)("input", {
                                                type: "checkbox",
                                                onChange: doUpdtSchedHold
                                            }, null, 32),
                                            _cache[12] || (_cache[12] = (0, vue_2.createTextVNode)("Update Current Scheduled Hold?", -1))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("span", _hoisted_28, [
                                        (0, vue_2.createElementVNode)("label", null, [
                                            (0, vue_2.createElementVNode)("input", {
                                                type: "checkbox",
                                                onChange: cancelSchedHold
                                            }, null, 32),
                                            _cache[13] || (_cache[13] = (0, vue_2.createTextVNode)("Cancel Current Scheduled Hold?", -1))
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
